export function mediaPublicUrl(item) {
  if (!item) return "";
  var path = item.url || "";
  if (!path) return "";
  if (path.indexOf("http://") === 0 || path.indexOf("https://") === 0) {
    return path;
  }
  var base = process.env.VUE_APP_PUBLIC_URL || "";
  if (base && base.charAt(base.length - 1) === "/") {
    base = base.slice(0, -1);
  }
  if (path.charAt(0) !== "/") {
    return base + "/" + path;
  }
  return base + path;
}

/** Apollo cache results are frozen — clone before local mutation. */
export function cloneApolloData(value) {
  if (value === null || value === undefined) return value;
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (e) {
    if (Array.isArray(value)) return value.slice();
    if (typeof value === "object") return Object.assign({}, value);
    return value;
  }
}

export const CAREER_FAIR_HERO_FIELDS = `
  id
  layout
  kicker
  title
  tagline
  hashtag
  button_1_label
  button_1_url
  button_2_label
  button_2_url
  banner_media_id
  circle_1_media_id
  circle_2_media_id
  circle_3_media_id
  circle_4_media_id
  bannerMedia { id url original_name media_type alt_text }
  circle1Media { id url original_name media_type alt_text }
  circle2Media { id url original_name media_type alt_text }
  circle3Media { id url original_name media_type alt_text }
  circle4Media { id url original_name media_type alt_text }
`;

export const CAREER_FAIR_FIELDS = `
  id
  year
  title
  slug
  is_published
  published_at
  created_at
  updated_at
  hero {
    ${CAREER_FAIR_HERO_FIELDS}
  }
  sections {
    id
    section_key
    title
    is_enabled
    sort_order
  }
`;
